module.exports = __webpack_public_path__ + "static/popup-waves-48f93e9efd560859bedad192a5153836.png";